import { MirrorService } from 'services/MirrorService';

import { getRandomItem } from 'helpers/array';

import hookupersCarouselPopupImg1 from 'assets/transfer/carousel-1.webp';
import localsDateCarouselPopupImg1 from 'assets/transfer/carousel-1_locals-date.webp';
import meplusyouCarouselPopupImg1 from 'assets/transfer/carousel-1_meplusyou.webp';
import hookupersCarouselPopupImg2 from 'assets/transfer/carousel-2.webp';
import localsDateCarouselPopupImg2 from 'assets/transfer/carousel-2_locals-date.webp';
import meplusyouCarouselPopupImg2 from 'assets/transfer/carousel-2_meplusyou.webp';
import hookupersCarouselPopupImg3 from 'assets/transfer/carousel-3.webp';
import localsDateCarouselPopupImg3 from 'assets/transfer/carousel-3_locals-date.webp';
import meplusyouCarouselPopupImg3 from 'assets/transfer/carousel-3_meplusyou.webp';
import hookupersDefaultPopupImg from 'assets/transfer/default.webp';
import localsDateDefaultPopupImg from 'assets/transfer/default_locals-date.webp';
import meplusyouDefaultPopupImg from 'assets/transfer/default_meplusyou.webp';

import { AVAILABLE_THEMES } from './constants';
import { PopupTheme } from './enums';

export const getRandomTheme = (themes: PopupTheme[]) => {
  return getRandomItem(themes);
};

export const getNextRandomTheme = (prevTheme: PopupTheme) => {
  const filteredThemes = AVAILABLE_THEMES.filter(
    (theme) => theme !== prevTheme
  );

  return getRandomTheme(filteredThemes);
};

export const getDefaultPopupImg = () => {
  let image = hookupersDefaultPopupImg;

  if (MirrorService.isMePlusYouOrLocalsjoy) {
    image = meplusyouDefaultPopupImg;
  }

  if (MirrorService.isLocalsDateOrLustStation) {
    image = localsDateDefaultPopupImg;
  }

  return image;
};

export const getCarouselPopupImgs = () => {
  let images = [
    hookupersCarouselPopupImg1,
    hookupersCarouselPopupImg2,
    hookupersCarouselPopupImg3,
  ];

  if (MirrorService.isMePlusYouOrLocalsjoy) {
    images = [
      meplusyouCarouselPopupImg1,
      meplusyouCarouselPopupImg2,
      meplusyouCarouselPopupImg3,
    ];
  }

  if (MirrorService.isLocalsDateOrLustStation) {
    images = [
      localsDateCarouselPopupImg1,
      localsDateCarouselPopupImg2,
      localsDateCarouselPopupImg3,
    ];
  }

  return images;
};
